<template>
	<div class="content">
		<LayoutBanner />

		<div class="work_tabs_box">
			<el-tabs class="work_tabs min_cw" v-model="activeName" @tab-click="handleClick">
				<el-tab-pane v-for="(item, index) in list" :key="index" :label="$getDictLabel(typeList, item.work_type)" :name="'' + item.work_id"></el-tab-pane>
			</el-tabs>
		</div>

		<div class="work min_cw ql-snow">
			<div class="con ql-editor" v-html="infoData.work_content"></div>
		</div>
	</div>
</template>

<script>
import LayoutBanner from "@/components/Layout/banner";
import {getDictDataApi, getWorkInfoApi, getWorkInfoListApi} from "@/api";

export default {
	name: "index",
	components: {
		LayoutBanner,
	},
	data() {
		return {
			loading: false,
			queryParams: {
				pageNum: 1,
				pageSize: 99,
				orderContent: "order_info asc",
			},

			list: [],
			typeList: [],
			infoData: {},

			activeName: '',
		}
	},
	created() {
		this.init();
	},
	methods: {
		async init() {
			this.loading = true;
			await this.initDict();
			await this.getList();
			this.loading = false;

			let id = this.$route.query.id ? this.$route.query.id : this.list[0].work_id;
			this.activeName = id + "";

			this.handleClick();
		},

		async getList() {
			const res = await getWorkInfoListApi(this.queryParams);
			this.list = res.rows;
		},

		/**
		 * 获取字典中的业务类型
		 */
		async initDict() {
			const res = await getDictDataApi("work_type");
			this.typeList = res.data;
		},

		async handleClick(tab, event) {
			this.infoData = {};
			let item = this.list.filter( cItem => cItem.work_id === parseInt(this.activeName) )[0];
			const res = await getWorkInfoApi(item.work_id);
			this.infoData = res.data;

			let queryId = this.$route.query.id ? parseInt(this.$route.query.id) : "";
			if(queryId !== item.work_id) this.$router.replace("/work?id=" + item.work_id);
		}
	}
}
</script>

<style lang="less" scoped>
.work {
	padding: 50px 40px 60px;
}

.work_tabs_box {
	width: 100%;
	height: 62px;
	background-color: @white;
	position: relative;

	.work_tabs {
		height: 100%;
		padding: 0 40px
	}

	.work_tabs /deep/ .el-tabs__header,
	.work_tabs /deep/ .el-tabs__nav-wrap,
	.work_tabs /deep/ .el-tabs__nav-scroll,
	.work_tabs /deep/ .el-tabs__nav,
	.work_tabs /deep/ .el-tabs__item {
		height: 100%;
	}

	.work_tabs /deep/ .el-tabs__item {
		line-height: 60px;
	}

	.work_tabs /deep/ .el-tabs__item.is-active,
	.work_tabs /deep/ .el-tabs__item:hover {
		color: @red;
	}

	.work_tabs /deep/ .el-tabs__active-bar {
		background-color: @red;
	}
}

.work_tabs_box::after {
	content: "";
	width: 100%;
	height: 2px;
	background-color: #E4E7ED;
	position: absolute;
	bottom: 0;
	left: 0;
}
</style>
